import jsonapi from 'jsonapi-parse';
import Checkout from '~/models/read/Checkout/Checkout';
import { getCurrencySymbol } from '~/functions/getCurrencySymbol';

export default $axios => ({ store }) => ({
    async get(id, includePaymentConfig) {
        const url = includePaymentConfig ? `/api/v1/checkout/${id}?include=paymentConfig` : `/api/v1/checkout/${id}`;
        let response = await $axios.$get(url);
        return new Checkout(jsonapi.parse(response).data);
    },

    async getCurrencies() {
        try {
            let response = await $axios.$get(`/api/v1/checkout/currencies`);

            let currenciesData = jsonapi.parse(response).data;

            let currenciesList = [];

            currenciesData.forEach(el => {
                currenciesList.push({
                    'abbreviation': el.id,
                    'symbol': getCurrencySymbol(store.state.locale.replace('_', '-'), el.id),
                });
            });

            return currenciesList;
        } catch (error) {
            console.error(error);
            store.app.$sentry.captureException(error);
            return [];
        }
    },

    async changeCurrency(orderId, currencyCode) {
        let response = await $axios.$put(`/api/v1/checkout/currencies/${orderId}/${currencyCode}`);
        store.$bus.$emit('changeCurrency', currencyCode);
        return response;
    },

    async getPromotions() {
        let response = await $axios.$get(`/api/v1/discounts`);
        return jsonapi.parse(response).data;
    },

    async addCouponToOrder(orderId, code) {
        let response = await $axios.$put(`/api/v1/checkout/order/${orderId}/code/${code}`);
        return response;
    },

    async addPlagiarismCoupon(orderId) {
        let response = await $axios.$post(`/api/v1/checkout/${orderId}/add-plagiarism-coupon`);
        return response;
    },

    async setPlagiarismBundle(orderId, bundleSize) {
        let response = await $axios.$put(`/api/v1/checkout/${orderId}/set-plagiarism-bundle`, {
            bundleSize,
        });
        return response;
    },
});
